import * as React from "react";
import { Link } from "react-router-dom";

export interface LinkSingleProps {
  title: string;
  subtitle?: string;
  to: string;
}

/**
 * A component for showing a link list item, used for sub-routing
 */
export const LinkSingle = (props: LinkSingleProps) => {
  return (
    <>
      <Link to={props.to} className="link__single link__single--nav">
        <div className="link__content">
          <span className="link__content-title">{props.title}</span>
          <span className="link__content-description">{props.subtitle}</span>
        </div>
        <span className="icon icon-open-chevron-right"></span>
      </Link>
    </>
  );
};
